// extracted by mini-css-extract-plugin
export default {"imageAboutPage":"AboutMe_imageAboutPage__LBIvs","aboutMe":"AboutMe_aboutMe__fkjzc","description":"AboutMe_description__DU-wp"};